import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DiagnosticPage from "@/pages/DiagnosticPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DiagnosticPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;